var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncreaseEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05235d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#305eba"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 42,
    height: 42,
    transform: "translate(505 489)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4",
    "data-name": "Mask Group 4",
    transform: "translate(-505 -489)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OUTLINE",
    transform: "translate(503.934 487.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M14.549,9.406h1.558V10.8H14.549Z",
    transform: "translate(-2.901 7.925) rotate(-26.565)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M18.821,36.944H11.85V31.368H10.456v6.971h.7v4.879h1.394V38.338h5.577v4.879h1.394V38.338h.7V31.368H18.821Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M39.036,26.626l-1.74,2.61a2.085,2.085,0,0,0-.351,1.16v.275a2.091,2.091,0,1,0,4.182,0V30.4a2.085,2.085,0,0,0-.351-1.16Zm.7,4.045a.7.7,0,1,1-1.394,0V30.4a.7.7,0,0,1,.117-.387l.58-.87.58.87a.7.7,0,0,1,.117.387Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M32.762,35.688l-1.74,2.61a2.085,2.085,0,0,0-.351,1.16v.275a2.091,2.091,0,1,0,4.182,0v-.275A2.085,2.085,0,0,0,34.5,38.3Zm.7,4.045a.7.7,0,0,1-1.394,0v-.275a.7.7,0,0,1,.117-.387l.58-.87.58.87a.7.7,0,0,1,.117.387Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M39.733,18.821v-.275a2.085,2.085,0,0,0-.351-1.16l-1.74-2.61-1.74,2.61a2.085,2.085,0,0,0-.351,1.16v.275a2.091,2.091,0,0,0,4.182,0Zm-2.788,0v-.275a.7.7,0,0,1,.117-.387l.58-.87.58.87a.7.7,0,0,1,.117.387v.275a.7.7,0,1,1-1.394,0Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M32.878,14.375l7.255-2.79a2.088,2.088,0,0,0,1.233-2.613L40.138,5.285a2.091,2.091,0,0,0-2.645-1.323L22.747,8.877A2.1,2.1,0,0,0,21.424,10.2l-.2.606L18.73,9.31,17.544,4.566a4.885,4.885,0,0,0,.58-2.317V1.218l-9.5,2.158a7.668,7.668,0,0,0-5.8,9.057l.139.662a11.192,11.192,0,0,0,7.387,8.283l.55.184.165.549A14.538,14.538,0,0,0,6.971,32.263V43.218H8.365V32.263a13.151,13.151,0,0,1,3.6-9.073l8.071,4.932A7.715,7.715,0,0,1,23.7,34.665v8.553h1.394V34.665a8.918,8.918,0,0,0-.105-1.358l7.082-2.213a4.88,4.88,0,0,0,3.3-5.739Zm-2.7-6.505.213.851a.7.7,0,0,1-.431.822L27.01,10.649a.7.7,0,0,1-.921-.484L25.873,9.3Zm-7.871,5.18V11.963l.441-1.323a.7.7,0,0,1,.441-.441l1.359-.453.189.757A2.092,2.092,0,0,0,27.5,11.954l2.949-1.106a2.09,2.09,0,0,0,1.294-2.465L31.5,7.428l6.43-2.143a.7.7,0,0,1,.882.441l1.229,3.687a.7.7,0,0,1-.411.871l-7.8,3-1.417.472a2.091,2.091,0,0,0-2.885-1.115l-.385.192a2.091,2.091,0,0,0-1.11,2.309l.084.392L24.3,15.9a.7.7,0,0,1-.63-.191l-1.171-1.171-1.718.573-.4-1.416Zm-11.9,6.87a9.8,9.8,0,0,1-6.08-7.111l-.139-.662a6.274,6.274,0,0,1,4.749-7.41l7.718-1.754a3.467,3.467,0,0,1-2.625,2.664l-2.522.582a4.162,4.162,0,0,0-3.161,4.9l.145.727h.951a1.391,1.391,0,0,1,.44,2.71l-.984.328Zm6.457-.3,1.009,5.55L12.441,21.85l-1.825-6.085a2.785,2.785,0,0,0-.954-5.3,2.773,2.773,0,0,1,2.157-2.879L14.341,7a4.886,4.886,0,0,0,2.108-1.069l1.068,4.273,3.18,1.908-2.033.678,1.162,4.068a.7.7,0,0,1-.534.875L17.962,18a1.4,1.4,0,0,0-1.1,1.616Zm1.372-.249,1.331-.266a2.091,2.091,0,0,0,1.6-2.625l-.007-.026.958-.319.562.562a2.088,2.088,0,0,0,1.889.572l1.841-.368,1.2,5.584a.7.7,0,0,1-.536.828l-7.814,1.675ZM24.67,31.946a9.115,9.115,0,0,0-3.912-5.014l-1.022-.625,7.1-1.522,2.117,5.821Zm6.985-2.183-1.368.427-2.135-5.87a2.088,2.088,0,0,0,.816-2.13L27.4,14.851a.7.7,0,0,1,.37-.77l.385-.192a.7.7,0,0,1,.973.4,1.3,1.3,0,0,0,1.637.818l.8-.265,2.459,10.819a3.5,3.5,0,0,1-2.359,4.1Z",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncreaseEnergy);
export default __webpack_public_path__ + "static/media/increase-energy.54ef53b15e246bb0ff65702c4118880b.svg";
export { ForwardRef as ReactComponent };